import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { PatternlibAngularWrapperModule } from '../patternlib-angular-wrapper.module';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ContentBoxComponent } from './components/content-box/content-box.component';
import { FooterComponent } from './components/footer/footer.component';
import { LanguageSelectComponent } from './components/language-select/language-select.component';
import { PortalPageComponent } from './components/portal-page/portal-page.component';
import { UserControlComponent } from './components/user-control/user-control.component';
import { ResizeObserverDirective } from './directives/resize-observer.directive';
import { UseRouterDirective } from './directives/use-router.directive';
import { FullNamePipe } from './pipes/full-name.pipe';
import { InitialsPipe } from './pipes/initials.pipe';
import { SafeHtmllPipe } from './pipes/safe-html.pipe';

@NgModule({
  declarations: [
    UseRouterDirective,
    ResizeObserverDirective,
    PortalPageComponent,
    FooterComponent,
    LanguageSelectComponent,
    ContentBoxComponent,
    BackButtonComponent,
    UserControlComponent,
    FullNamePipe,
    InitialsPipe,
    SafeHtmllPipe,
    BreadcrumbComponent,
  ],
  imports: [CommonModule, RouterModule, TranslateModule, PatternlibAngularWrapperModule],
  exports: [
    UseRouterDirective,
    ResizeObserverDirective,
    PortalPageComponent,
    FullNamePipe,
    InitialsPipe,
    SafeHtmllPipe,
    ContentBoxComponent,
    BreadcrumbComponent,
    RouterModule,
    TranslateModule,
    PatternlibAngularWrapperModule,
  ],
})
export class PatternlibAngularCommonModule {}
